import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import greaterThan from "../../../assets/images/ipad-icons/greaterThan.png";
import lesserThan from "../../../assets/images/ipad-icons/lesserThan.png";
import line from "../../../assets/images/ipad-icons/line.png";
class IpadPaginationClass extends Component {
  state = {
    goToPage: "",
  };
  handleKeyPress = (event) => {
    let { goToPage } = this.state;
    let { total_pages } = this.props.pageMeta;
    if (event.key === "Enter") {
      event.preventDefault();
      if (goToPage <= total_pages) {
        this.props.handlePagination(goToPage);

        this.setState({ goToPage: "" });
      } else {
        this.setState({ goToPage: "" });
      }
    }
  };
  handleGoToChange = () => {
    let { total_pages } = this.props.pageMeta;
    let { goToPage } = this.state;

    if (goToPage <= total_pages) {
      this.props.handlePagination(goToPage);

      this.setState({ goToPage: "" });
    } else {
      this.setState({ goToPage: "" });
    }
  };
  render() {
    let {
      current_page = 1,
      per_page = 10,
      total_pages = 1,
      total = 1,
    } = this.props.pageMeta || {};
    console.log(total_pages, "total");
    console.log(current_page, "currentPage");
    let { t } = this.props;
    let { goToPage } = this.state;
    if (total_pages <= 1) {
      return "";
    }

    return this.props.pageMeta ? (
      <div className="d-flex text-center w-100 justify-content-end ipad-pagination pr-4 py-3 ">
        <p className="m-0 d-flex align-items-center font-sm list-page">
          <p
            className={`btn-effect
             ${Number(current_page) === 1 ? "disable" : ""}
            table-left-arrow previous-button  cursor-pointer`}
            disabled={Number(current_page) === 1}
            onClick={(e) =>
              Number(current_page) !== 1 &&
              this.props.handlePagination(
                Number(current_page) !== 0 ? Number(current_page) - 1 : 0
              )
            }
          >
            <img className="ipad-icon" src={lesserThan} alt="lesserThan" />
            {/* {t("<")} */}
            <span className="icon-Group-4 font-md cursor-pointer" />
          </p>
          {(Number(current_page) === Number(total_pages) ||
            Number(total_pages) < 3) &&
          Number(current_page) !== 1 ? (
            <span
              onClick={(e) => this.props.handlePagination(1)}
              className="page-number text-center cursor-pointer"
            >
              {1}
            </span>
          ) : (
            ""
          )}
          <span
            onClick={(e) =>
              Number(current_page) !== Number(total_pages) &&
              this.props.handlePagination(Number(current_page) + 1)
            }
            className="active page-number cursor-pointer"
          >
            {Number(current_page)}
          </span>
          {Number(current_page) + 1 > Number(total_pages) ? (
            ""
          ) : (
            <span
              onClick={(e) =>
                Number(current_page) !== Number(total_pages)
                  ? this.props.handlePagination(Number(current_page) + 1)
                  : ""
              }
              className="page-number cursor-pointer"
            >
              {Number(current_page) + 1}
            </span>
          )}
          {Number(current_page) + 2 > Number(total_pages) ? (
            ""
          ) : (
            <span
              onClick={(e) =>
                Number(current_page) !== Number(total_pages) &&
                this.props.handlePagination(Number(current_page) + 2)
              }
              className="page-number cursor-pointer"
            >
              {Number(current_page) + 2}
            </span>
          )}
          {Number(current_page) === Number(total_pages) - 2 ||
          Number(current_page) === Number(total_pages) - 1 ||
          Number(current_page) === Number(total_pages) ? (
            ""
          ) : (
            // <span
            //   onClick={(e) =>
            //     Number(current_page) !== Number(total_pages) &&
            //     this.props.handlePagination(Number(current_page))
            //   }
            //   className="page-number cursor-pointer"
            // >
            //   {Number(total_pages)}
            // </span>
            <>
              <span>.....</span>
              <span
                onClick={(e) =>
                  this.props.handlePagination(Number(total_pages))
                }
                className="page-number cursor-pointer"
              >
                {Number(total_pages)}
              </span>
            </>
          )}
          <p
            className={`btn-effect ${
              Number(current_page) === Number(total_pages) ? "disable" : ""
            } table-right-arrow next-button cursor-pointer`}
            disabled={Number(current_page) === Number(total_pages)}
            onClick={(e) =>
              Number(current_page) !== Number(total_pages) &&
              this.props.handlePagination(
                Number(current_page) !== Number(total_pages)
                  ? Number(current_page) + 1
                  : Number(total_pages)
              )
            }
          >
            {/* {t(">")} */}
            <img className="ipad-icon" src={greaterThan} alt="greaterThan" />
            <span className="font-md icon-Group-4 cursor-pointer" />
          </p>
          {/* <div>
            <img src={goToPage} alt="goToPage" />
          </div> */}
        </p>
        <div className="goToPage">
          <input
            type={"text"}
            name="goToPage"
            value={goToPage}
            onChange={(e) => this.setState({ goToPage: e.target.value })}
            className=" page-input w-100 h-100"
            onKeyDown={this.handleKeyPress}
          />
          {/* {t(">")} */}
          <img
            className="input-arrow-icon"
            src={greaterThan}
            onClick={() => this.handleGoToChange()}
            alt="greaterThan"
          />
          <img className="input-line-icon" src={line} alt="line" />
          <p className="input-goTo">Go To Page</p>
        </div>
      </div>
    ) : (
      ""
    );
  }
}
export const IpadPagination = withTranslation()(IpadPaginationClass);
